export default __webpack_public_path__ + "static/media/designThinking.cda1fef4.svg";